import React, { useState, useEffect } from 'react';
import ContractorCard from './ContractorCard';
import Header from "../../../layouts/Header";
import {getContractors, getUserInfo} from "../api/ProfileAPIs";
import {showError} from "../../../utils/toastHelper";
import {getCities, getStates} from "../../auth/api/authApi";
import Select from "react-select";


const ContractorList = () => {
    const [users, setUsers] = useState([]);
    const [vendorsCity, setVendorsCity] = React.useState(window.localStorage.getItem('_ci') || 0);

    const [states, setStates] = useState([]);
    const [state, setState] = useState(0);
    const [cities, setCities] = useState([]);

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const params = {
                    list: 1,
                    group_id: 2,
                    city_id: vendorsCity
                }
                const response = await getContractors(params);
                setUsers(response.data);

            } catch (err) {
                showError('خطا در بارگذاری اطلاعات .');
            }
        };
        fetchUserData();
    }, [vendorsCity]);


    React.useEffect(() => {
        const fetchStates = async () => {
            try {
                const params ={
                    'country_id' : 1,
                    'count' : 40
                }
                const data = await getStates(params);
                const st = data.data;
                let options = [];
                for (let data in st) {
                    options.push({
                        value: st[data].id,
                        label: st[data].name ,
                    })
                }
                setStates(options)

            } catch (err) {
                showError( err);
            } finally {

            }
        };
        fetchStates();

    }, []);

    React.useEffect(() => {
        const fetchCities = async () => {
            try {
                const params ={
                    'state_id' : state.value,
                    'count' : 40
                }
                const data = await getCities(params);
                const c = data.data;
                let options = [];
                for (let data in c) {
                    options.push({
                        value: c[data].id,
                        label: c[data].name ,
                    })
                }
                setCities(options)

            } catch (err) {
                showError( err);
            } finally {

            }
        };
        if (state.value > 0) {
            fetchCities();
        }


    }, [state]);


    return (
        <div className="container py-5 bg-light mt-3">
            <Header hasBack={true} transparent={false} title='لیست پیمانکاران'/>
            <div className="row justify-content-center">
                <div className='row pb-4'>

                    <div className="col-6 text-center mt-3 border-bottom pb-4">
                        <Select
                            options={states}
                            placeholder="    استان  "
                            value={state}
                            noOptionsMessage={() => "عدم دریافت لیست استانها"}
                            isSearchable={true}
                            onChange={

                                (event) => {
                                    setState(event)
                                    setVendorsCity(0)
                                }
                            }
                        />
                    </div>


                    <div className="col-6 text-center mt-3 border-bottom pb-4">
                        <Select
                            options={cities}
                            placeholder="    شهر  "
                            value={vendorsCity}
                            noOptionsMessage={() => "شهری پیدا نشد"}
                            isSearchable={true}
                            onChange={

                                (event) => {
                                    setVendorsCity(event);


                                }
                            }
                        />
                    </div>


                </div>
                <div className="col-lg-8 col-md-10">

                    {users.map(contractor => (
                        <ContractorCard key={contractor.id} contractor={contractor}/>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ContractorList;
